import { useState } from "react";
import { RadioGroup } from "../../ui/RadioGroup";
import { SubHead } from "../../ui/SubHead";
import { Select } from "../../ui/Select";
import { yesNoOption } from "../../options/options";
import { Input } from "../../ui/Input";
import { values } from "pdf-lib";
import { Textarea } from "../../ui/Textarea";
import { Button } from "../../ui/button";
import ConfirmActionModal from "../../ui/ConfirmActionModal";
import ConfirmationModal from "../../ui/ConfirmationModal";
import { userSession } from "../../../observers/userObserver";

export const EDDForm = ({
  handleSearch,
  formData,
  handleChange,
  isReadOnly,
  handleSubmit,
  sendMail,
  clientType
}) => {
  const userEmail = userSession.getUserEmail();
  const [showcompleteModal, setShowCompleteModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  return (
    <div className="transaction-form form_information">
      <h2 className="edd-head">Enhanced Due Diligence
        <div className="email_button-group" style={{ padding: "0" }}>
          <span>Need Assitance ?</span>
          <button type="button" onClick={() => sendMail("MLNO")}>   Contact MLNO</button>
          <button type="button" onClick={() => sendMail("COD")}>  Contact COnD</button>
        </div>
      </h2>
      <form onSubmit={handleSubmit}>
        {(!clientType || clientType === "Tenant" || clientType === "Purchaser") && (
          <>
            <SubHead text="Purchasers or Tenants" />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Source of Wealth</h4>
            <Select
              label="What is the source of the client/counterparty’s overall wealth?"
              name="PurchaserwealthSource"
              value={formData.PurchaserwealthSource}
              onChange={handleChange}
              disabled={isReadOnly}
              options={[
                { value: "Inheritance", display_value: "Inheritance (e.g., estates, family trusts)" },
                { value: "real-estate", display_value: "Profits from commercial real estate ventures" },
                { value: "business-sale", display_value: "Sale of businesses or shares" },
                { value: "professional-earnings", display_value: "Professional earnings (e.g., legal, medical, consultancy practices)" },
                { value: "investments", display_value: "Long-term investments (e.g., stocks, bonds, private equity funds)" },
                { value: "property-income", display_value: "Ownership and income from other properties" },
                { value: "entrepreneurship", display_value: "Entrepreneurial ventures or startup success" },
                { value: "royalties", display_value: "Royalties or intellectual property income" },
                { value: "Other", display_value: "Other (please specify)" },
                { value: "Unknown", display_value: "Unknown" }
              ]}
            />
            {formData.PurchaserwealthSource === "Other" && (
              <Input
                label="Please specify"
                type="text"
                name="PurchaserWealthSourceOther"
                value={formData.PurchaserWealthSourceOther}
                onChange={handleChange}
                placeholder="Please specify"
                disabled={isReadOnly}
                style={{ marginTop: "10px", width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
              />
            )}
            <Input
              label="Over what timeframe was this wealth accumulated?"
              type="text"
              name="PurchaserTimeframeWealthAccumlated"
              value={formData.PurchaserTimeframeWealthAccumlated}
              onChange={handleChange}
              placeholder="specify timeframe"
              disabled={isReadOnly}
            />
            <Textarea
              label="How and why does the individual/entity possess their overall assets?"
              type="text"
              name="PurchaserHowPossessTheirOverallAssests"
              disabled={isReadOnly}
              value={formData.PurchaserHowPossessTheirOverallAssests}
              onChange={handleChange}
            />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Client/Counterparty Relationship </h4>
            <RadioGroup
              label={`Is this a new relationship? `}
              name="PurchaserIsRelationshipNew"
              value={formData.PurchaserIsRelationshipNew}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
            />
            {formData.PurchaserIsRelationshipNew === "No" && (
              <Select
                label="How long have you known this client for?"
                name="PurchaserClientKnownDuration"
                value={formData.PurchaserClientKnownDuration}
                onChange={handleChange}
                disabled={isReadOnly}
                options={[
                  { value: " ", display_value: "Select duration" },
                  { value: "0-6 months", display_value: "0-6 months" },
                  { value: "6-12 months", display_value: "6-12 months" },
                  { value: "1–3 years", display_value: "1–3 years" },
                  { value: "3 years +", display_value: "3 years +" }
                ]}
              />
            )}
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Verification of Wealth</h4>
            <Textarea
              label="Steps taken to verify the legitimacy of the wealth:"
              type="text"

              name="PurchaserStepsTakenToverifyWealth"
              disabled={isReadOnly}
              value={formData.PurchaserStepsTakenToverifyWealth}
              onChange={handleChange}
              placeholder="(Examples: Reviewed Documentation, conducted third-party checks, review of independent sources)"
            />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Source of Funds</h4>
            <button onClick={() => setShowConfirmModal(true)} style={{marginTop: "10px",padding: "8px", border: "none", background: "rgb(7, 177, 176)",color: "white",borderRadius: "4px", cursor: "pointer",float: "left"}}>                                Check Source of Funds
                            </button>
            <Textarea
              label="Specify the source of funds for the transaction and how they were generated (e.g., business profits, asset sale, loan):"
              type="text"
              name="SourceOfFundForTransactionGenerated"
              disabled={isReadOnly}
              value={formData.SourceOfFundForTransactionGenerated}
              onChange={handleChange}
              placeholder="Please Specify"
            />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Details of the bank account from which funds will be transferred.</h4>
            <Input
              label="Bank Name"
              type="text"
              name="SourceBankName"
              value={formData.SourceBankName}
              onChange={handleChange}
              disabled={isReadOnly}
            />
            <Input
              label="Bank Account Number"
              type="text"
              name="SourceAccountNumber"
              value={formData.SourceAccountNumber}
              onChange={handleChange}
              disabled={isReadOnly}
            />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Verification Steps</h4>
            <RadioGroup
              label={`Have the client’s instructions regarding the source of funds been independently verified? `}
              name="PurchaserFundSourceVerifiedIndependently"
              value={formData.PurchaserFundSourceVerifiedIndependently}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
            />
            {formData.PurchaserFundSourceVerifiedIndependently === "Yes" && (
              <Textarea
                label="Please provide details of how the funds were independently verified:"
                type="text"
                name="PurchaseFundVerifiedDetail"
                disabled={isReadOnly}
                value={formData.PurchaseFundVerifiedDetail}
                onChange={handleChange}
                placeholder="For example, via an independent third party such as thier solicitors, etc"
              />
            )}
          </>
        )}

        {(!clientType || clientType === "Landlord" || clientType === "Vendor") && (
          <>
            <SubHead text="Sellers or Landlords" />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Source of Wealth</h4>
            <Select
              label="What is the source of the client/counterparty’s overall wealth?"
              name="SellerWealthSource"
              value={formData.SellerWealthSource}
              onChange={handleChange}
              disabled={isReadOnly}
              options={[
                { value: "Inheritance", display_value: "Inheritance (e.g., estates, family trusts)" },
                { value: "real-estate", display_value: "Profits from commercial real estate ventures" },
                { value: "business-sale", display_value: "Sale of businesses or shares" },
                { value: "professional-earnings", display_value: "Professional earnings (e.g., legal, medical, consultancy practices)" },
                { value: "investments", display_value: "Long-term investments (e.g., stocks, bonds, private equity funds)" },
                { value: "property-income", display_value: "Ownership and income from other properties" },
                { value: "entrepreneurship", display_value: "Entrepreneurial ventures or startup success" },
                { value: "royalties", display_value: "Royalties or intellectual property income" },
                { value: "Other", display_value: "Other (please specify)" },
                { value: "Unknown", display_value: "Unknown" }
              ]}
            />
            {formData.SellerWealthSource === "Other" && (
              <Input
                label="Please specify"
                type="text"
                name="SellerWealthSourceOther"
                value={formData.SellerWealthSourceOther}
                onChange={handleChange}
                placeholder="Please specify"
                disabled={isReadOnly}
                style={{ marginTop: "10px", width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
              />
            )}
            <Input
              label="Over what timeframe was this wealth accumulated?"
              type="text"
              name="SellerTimeframeWealthAccumlated"
              value={formData.SellerTimeframeWealthAccumlated}
              onChange={handleChange}
              placeholder="specify timeframe"
              disabled={isReadOnly}
            />
            <Textarea
              label="How and why does the individual/entity possess their overall assets?"
              type="text"
              name="SellerHowPossessTheirOverallAssests"
              disabled={isReadOnly}
              value={formData.SellerHowPossessTheirOverallAssests}
              onChange={handleChange}
            />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Client/Counterparty Relationship </h4>
            <RadioGroup
              label={`Is this a new relationship? `}
              name="SellerIsRelationshipNew"
              value={formData.SellerIsRelationshipNew}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
            />
            {formData.SellerIsRelationshipNew === "No" && (
              <Select
                label="How long have you known this client for?"
                name="SellerClientKnownDuration"
                value={formData.SellerClientKnownDuration}
                onChange={handleChange}
                disabled={isReadOnly}
                options={[
                  { value: " ", display_value: "Select duration" },
                  { value: "0-6 months", display_value: "0-6 months" },
                  { value: "6-12 months", display_value: "6-12 months" },
                  { value: "1–3 years", display_value: "1–3 years" },
                  { value: "3 years +", display_value: "3 years +" }
                ]}
              />
            )}
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Verification of Wealth</h4>
            <Textarea
              label="Steps taken to verify the legitimacy of the wealth:"
              type="text"
              name="SellerStepsTakenToverifyWealth"
              disabled={isReadOnly}
              value={formData.SellerStepsTakenToverifyWealth}
              onChange={handleChange}
              placeholder="(Examples: Reviewed Documentation, conducted third-party checks, review of independent sources)"
            />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Destination of Funds</h4>
            <Textarea
              label="Describe the nature of the seller/landlord’s business"
              type="text"
              name="SellerBussinessNature"
              disabled={isReadOnly}
              value={formData.SellerBussinessNature}
              onChange={handleChange}
              placeholder="Please Specify"
            />
            <RadioGroup
              label={`Have steps been taken to independently verify this information? `}
              name="SellerFundSourceVerifiedIndependently"
              value={formData.SellerFundSourceVerifiedIndependently}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
            />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Property Mortgage</h4>
            <RadioGroup
              label={`Is there a mortgage on the property? `}
              name="MortgageOnProperty"
              value={formData.MortgageOnProperty}
              disabled={isReadOnly}
              onChange={handleChange}
              options={yesNoOption}
            />
            {formData.MortgageOnProperty === "Yes" && (
              <Input
                label="Mortgage Bank Name"
                type="text"
                name="MortgageBankName"
                value={formData.MortgageBankName}
                onChange={handleChange}
                disabled={isReadOnly}
              />
            )}
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Details of the bank account from which funds will be transferred.</h4>
            <Input
              label="Bank Name"
              type="text"
              name="DestinationBankName"
              value={formData.DestinationBankName}
              onChange={handleChange}
              disabled={isReadOnly}
            />
            <Input
              label="Bank Account Number"
              type="text"
              name="DestinationAccountNumber"
              value={formData.DestinationAccountNumber}
              onChange={handleChange}
              disabled={isReadOnly}
            />
            <h4 style={{ margin: "10px 0", textDecoration: "underline" }}>Further Information</h4>
            <Textarea
              label="Do you have any further information detailing the application of enhanced due diligence, including any potential suspicions?"
              type="text"
              name="FurthurInformation"
              disabled={isReadOnly}
              value={formData.FurthurInformation}
              onChange={handleChange}
              placeholder="provide further information"
            />
            <ConfirmActionModal
  visible={showConfirmModal}
  message="Are you sure you want to check the source of funds?"
  onConfirm={() => {
    handleSearch();
    setShowConfirmModal(false);
    setShowCompleteModal(true);
  }}
  onCancel={() => setShowConfirmModal(false)}

/>

    <ConfirmationModal
            isOpen={showcompleteModal}
            onClose={() => setShowCompleteModal(false)}
            message={" Search  for source of funds has been successfully processed. The report will be emailed to " + userEmail + " in 30 minutes."}
        />


          </>
          
        )}
      </form>
    </div>
  )
}